import React, {useState} from 'react';
import {innerStyle} from "../../../../styles/pages/home/MaterialYouBaseStyle";
import {Avatar, Button, Divider, Fab, Grow, Paper, Slide, Typography, useTheme, Zoom} from "@mui/material";
import {useHistory} from "react-router-dom";
import {indigo} from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import Grid from "@mui/material/Grid";
import SVG from "react-inlinesvg";
import multiavatar from "@multiavatar/multiavatar";
import {getAccountInfo, getUserNameAndSurname} from "../../../../utils/GenericUtils";
import {useForm, FormProvider} from "react-hook-form";

const GestioneCarico = () => {
	const classes = innerStyle();
	let theme = useTheme();
	let history = useHistory();
	const methods = useForm({mode: "onChange",});
	
	const [open, setOpen] = useState(false)
	
	return (
        <React.Fragment>
            <main className={classes.main} style={{width: "100%"}}>
				{/*<header style={{
				 display: "flex",
				 justifyContent: "center",
				 paddingBottom: 28,
				 paddingTop: 20,
				 }}>
				 <Typography variant={"h1"} component={"h1"} align={"center"}
				 style={{color: indigo["A700"]}}>
				 <b>
				 Carico dati
				 </b>
				 </Typography>
				 </header>*/}
				<Grid container spacing={4} component={"article"} style={{padding: 20}}>
					<Grid item xs={12}>
						<Slide direction={"up"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "200ms"}}>
							<Paper className={classes.paper}>
								<Zoom in={true} style={{transitionDelay: "800ms"}}>
									<IconButton
                                        className={classes.backButton}
                                        onClick={() => history.goBack()}
                                        size="large">
										<ArrowBackIosRoundedIcon fontSize="small"/>
									</IconButton>
								</Zoom>
								<Typography variant={"h4"} component={"h1"}
								            style={{paddingLeft: 6, display: "inline-block", verticalAlign: "bottom"}}>
									<b>Tamponi</b>
								</Typography>
								<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
									Segui la procedura per caricare correttamente i tamponi dalla piattaforma regionale gestione pazienti.
								</Typography>
								
								<Grid container spacing={4} style={{marginTop: 10}}>
									<Grid item xs={12}>
										<Typography variant={"body2"} color={"textSecondary"}>
											<ol>
												<li>Accedere a <a href={"https://webcovid.sdp.csi.it/gestionepazienti"}
												                  target={"_blank"} rel={"noreferrer"}>Gestione Pazienti</a>
												</li>
												<li>Andare su "Tamponi" e poi su "Richieste tamponi" nel menù laterale</li>
												<li>Impostare i filtri su esito e date desiderate</li>
												<li>Cliccare sul bottone carica e selezionare il file appena scaricato</li>
												<li>Cliccare su conferma</li>
											</ol>
										</Typography>
									</Grid>
									<Grid item xs={12} style={{display: "flex"}}>
										<FormProvider {...methods}>
											<Button variant={"contained"} disableElevation color={"primary"}
											        style={{borderRadius: 22, margin: "auto", fontSize: 24}}>
												Carica
											</Button>
										</FormProvider>
									</Grid>
									<Grid item xs={12}>
										tabella che fa refresh auto o a scelta..
									</Grid>
								</Grid>
							
							</Paper>
						</Slide>
					</Grid>
					
					<Grid item xs={12}>
						<Slide direction={"up"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "600ms"}}>
							<Paper className={classes.paper}>
								<Zoom in={true} style={{transitionDelay: "800ms"}}>
									<IconButton
                                        className={classes.backButton}
                                        onClick={() => history.goBack()}
                                        size="large">
										<ArrowBackIosRoundedIcon fontSize="small"/>
									</IconButton>
								</Zoom>
								<Typography variant={"h4"} component={"h1"}
								            style={{paddingLeft: 6, display: "inline-block", verticalAlign: "bottom"}}>
									<b>Anagrafiche</b>
								</Typography>
								<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
									Crea un'anagrafica all'interno di Ocean.
								</Typography>
								
								<Grid container spacing={4} style={{marginTop: 10}}>
									<Grid item xs={12}>
										input per l'anagrafica soliti...
									</Grid>
								</Grid>
							
							</Paper>
						</Slide>
					</Grid>
				</Grid>
			</main>
            <Fab color={"default"} style={{
				position: "fixed",
				top: 10,
				right: 10,
				boxShadow: theme.shadows[20],
				borderRadius: 22,
				color: indigo["50"],
				backgroundColor: indigo["A700"],
			}} onClick={() => setOpen(!open)}>
				<lord-icon
					src="https://cdn.lordicon.com/dklbhvrt.json"
					trigger="hover"
					colors="primary:#ffffff">
				</lord-icon>
			</Fab>
            <Grow in={open} mountOnEnter unmountOnExit style={{transformOrigin: '1000px 0 0'}}>
				<Paper elevation={20} className={classes.chatProfilePaper}>
					<Grid container spacing={4}>
						<Grid item xs={12} style={{display: "flex"}}>
							<Avatar style={{
								margin: "auto", marginTop: 40, width: 120,
								height: 120,
							}}>
								<SVG src={multiavatar(getAccountInfo().alias)}/>
							</Avatar>
						</Grid>
						<Grid item xs={12}>
							<Typography variant={"h2"} align={"center"} style={{fontSize: 24}}>
								<b>{getUserNameAndSurname()}</b>
							</Typography>
						</Grid>
						<Grid item xs={12} style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
							<Divider style={{width: 280, alignSelf: "center", marginBottom: 10}}/>
							<Button style={{marginLeft: 10, borderRadius: 22}}>
								<lord-icon
									src="https://cdn.lordicon.com/ryyjawhw.json"
									trigger="loop-on-hover">
								</lord-icon>
								<span style={{marginLeft: 10}}>Impostazioni</span>
							</Button>
							<Button style={{marginLeft: 10, borderRadius: 22}}>
								<lord-icon
									src="https://cdn.lordicon.com/igpbsrza.json"
									trigger="loop-on-hover">
								</lord-icon>
								<span style={{marginLeft: 10}}>Pagina iniziale</span>
							</Button>
							<Button style={{marginLeft: 10, borderRadius: 22}}>
								<lord-icon
									src="https://cdn.lordicon.com/xhebrhsj.json"
									trigger="loop-on-hover">
								</lord-icon>
								<span style={{marginLeft: 10}}>Azioni</span>
							</Button>
						</Grid>
						<Grid item xs={12}>
							<Button style={{marginLeft: 10, borderRadius: 22}}>
								<lord-icon
									src="https://cdn.lordicon.com/lywgqtim.json"
									trigger="loop-on-hover"
									colors="primary:#121331,secondary:#1663c7"
								>
								</lord-icon>
								<span style={{marginLeft: 10}}>Esci</span>
							</Button>
						</Grid>
					</Grid>
				</Paper>
			</Grow>
        </React.Fragment>
    );
}

export default React.memo(GestioneCarico)
